module.exports = __webpack_public_path__ + "img/pvc_expomoda_shiny_0105_silver_250x250.c3fead85.jpg";